module.exports = __webpack_public_path__ + "img/btn_service.03a74757.png";